import React, { useEffect, useMemo, useRef } from 'react';
import { default as SliderAndVcpuComponent, PipeVcpu } from '../SliderComplete/SliderAndVcpu';
import { UHC_SliderProps } from '../../../Dumb/Organisms/Slider/Slider';
import { convertDatasToPipes, CurrentProfile, getElementsSliderConfig, Pipes, ServerCatalog, setSlideMinOrIncluded, UHCSlider } from '../../../..';
import { BoxVcpu, SliderBox, TitleConfig, TitlePriceBox } from './AdvancedSettings.style';
import { Image } from '../../Cloud.model'
import { SliderColorsOptions } from '@/components/Dumb/Organisms/Slider/sliderColors';

export interface UHCSliderProps {
    pipes: PipeVcpu[],
    pipeState: UHC_SliderProps['pipeState'],
    pipesDisabled?: {
        min: number,
        max: number
    },
    price?: string
}

export interface UHCSliderCompleteProps {
    color: SliderColorsOptions
    serverCatalog: ServerCatalog,
    hardwareSelectedIndex: CurrentProfile,
    currentImage: Image
}

const UHCTemplateAdvancedSettings: React.FC<UHCSliderCompleteProps> = ({ serverCatalog,
    hardwareSelectedIndex,
    currentImage,
    color }) => {


    const prevCountRef = useRef<number>(hardwareSelectedIndex.compute[0]);
    const pipesConverted = useMemo<Pipes>(() => convertDatasToPipes(
        serverCatalog,
        currentImage,
        hardwareSelectedIndex
    ), [hardwareSelectedIndex.compute[0], currentImage]);


    const [compute, bandwidth, disk] = getElementsSliderConfig(
        pipesConverted,
        hardwareSelectedIndex,
        serverCatalog,
        currentImage
    )

    useEffect(() => {
        setSlideMinOrIncluded(serverCatalog,
            hardwareSelectedIndex,
            prevCountRef.current,
            currentImage)
        prevCountRef.current = hardwareSelectedIndex.compute[0];
    }, [hardwareSelectedIndex.compute[0]])



    return (
        <div data-testid='template-AdvancedSettings' id='advancedSettings'>
            <BoxVcpu margin={30}>
                <TitlePriceBox>
                    <TitleConfig id="memory-title">Memória e Processamento</TitleConfig> <TitleConfig>{compute.price}</TitleConfig>
                </TitlePriceBox>

                <SliderBox>
                    <SliderAndVcpuComponent color={color} {...compute} aria-labelledBy="memory-title" />
                </SliderBox>
            </BoxVcpu>

            <BoxVcpu margin={80}>
                <TitlePriceBox>
                    <TitleConfig id="banda-title">Banda</TitleConfig> <TitleConfig>{bandwidth.price}</TitleConfig>
                </TitlePriceBox>

                <SliderBox>
                    <UHCSlider
                        color={color}
                        aria-labelledBy="banda-title"
                        pipeState={{ pipeSelected: bandwidth.pipeState.pipeSelected, setPipeSelected: bandwidth.pipeState.setPipeSelected }}
                        pipes={bandwidth.pipes}
                        pipesDisabled={bandwidth.pipesDisabled} />
                </SliderBox>
            </BoxVcpu>

            <BoxVcpu margin={80} style={{ marginBottom: 40 }}>
                <TitlePriceBox>
                    <TitleConfig id="disk-title">Disco</TitleConfig> <TitleConfig>{disk.price}</TitleConfig>
                </TitlePriceBox>

                <SliderBox>
                    <UHCSlider
                        color={color}
                        aria-labelledBy="disk-title"
                        pipeState={{ pipeSelected: disk.pipeState.pipeSelected, setPipeSelected: disk.pipeState.setPipeSelected }}
                        pipes={disk.pipes}
                        pipesDisabled={disk.pipesDisabled} />
                </SliderBox>
            </BoxVcpu>
        </div>
    );
};

export default UHCTemplateAdvancedSettings;